import { useEffect, useReducer } from 'react';
import { useAsync, useWindowSize } from 'react-use';
import {
  hasRelatedApps as getHasRelatedApps,
  isStandalone as getIsStandalone,
  getIsTelegramMiniApp,
  parseUserAgent,
} from './js';

const LAUNCH_SOURCE_KEY = 'launch_source';
const initLaunchSource = () => {
  const url = new URL(window.location.href);
  const searchParam = url.searchParams.get(LAUNCH_SOURCE_KEY);
  if (searchParam) {
    localStorage.setItem(LAUNCH_SOURCE_KEY, searchParam);
  }
};

const getLaunchSource = () => localStorage.getItem(LAUNCH_SOURCE_KEY);

export const useRuntimeEnv = () => {
  const [tick, nextTick] = useReducer((p) => p + 1, 1);
  useEffect(() => {
    initLaunchSource();
    nextTick();
  }, []);
  const hasRelatedApps = useAsync(getHasRelatedApps);
  const size = useWindowSize();
  const launchSource = getLaunchSource();
  const isStandalone = getIsStandalone();
  const parsedUserAgent = parseUserAgent(window.navigator.userAgent);
  const isTelegramMiniApp = getIsTelegramMiniApp();

  return {
    isStandalone,
    isTelegramMiniApp,
    launchSource,
    size,
    hasRelatedApps: hasRelatedApps.value,
    ...parsedUserAgent,
    ...(tick && {}),
  };
};
